export default __webpack_public_path__ + "static/media/cash.a81b3ed4.png";